module.exports = __webpack_public_path__ + "static/hero_img_mobile-1167f336b1f7411983ef8b1ad1ad69c6.jpg";